var _style, _path, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAnalog = function SvgAnalog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "analog_svg__Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 106 106",
    style: {
      enableBackground: "new 0 0 106 106"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".analog_svg__st6{fill:#23d5ae}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "analog_svg__st6",
    d: "M98 37.2H9.1c-2.4 0-4.4 2-4.4 4.4v22.8c0 2.4 2 4.4 4.4 4.4H98c2.4 0 4.4-2 4.4-4.4V41.6c0-2.4-2-4.4-4.4-4.4zM9.6 42h61.9v22H9.6V42zm88 22H76.2V42h21.3v22z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "analog_svg__st6",
    cx: 87.1,
    cy: 53,
    r: 3.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "analog_svg__st6",
    cx: 22.4,
    cy: 53,
    r: 3.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "analog_svg__st6",
    cx: 40.4,
    cy: 53,
    r: 3.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "analog_svg__st6",
    cx: 58.4,
    cy: 53,
    r: 3.6
  })));
};

export default SvgAnalog;